import Swiper from "swiper";
import { Navigation, Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";

export const initProductGallery = (): void => {
  const galleries = document.querySelectorAll<HTMLElement>(
    ".product-gallery__slider",
  );

  if (galleries.length === 0) {
    return;
  }

  galleries.forEach((gallery) => {
    new Swiper(gallery, {
      modules: [Navigation, Pagination, Autoplay],
      slidesPerView: 1,
      spaceBetween: 10,
      loop: true,
      autoplay: {
        delay: 4000,
        disableOnInteraction: true,
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
    });
  });

  console.log(
    `[Product Gallery] Initialized ${galleries.length} product sliders.`,
  );
};
